module.exports = __webpack_public_path__ + "static/media/plp.logo.240w.e523055f.png";